module.exports = __webpack_public_path__ + "img/technologyBox.a3afa029.png";